export default "__VITE_ASSET__DWdk1FjQ__"